import { useState, useEffect } from 'react';

const useServices = () => {
  const [services, setServices] = useState([]);
  let baseUrl;

  // Determine the current domain
  const currentDomain = window.location.hostname;

  if (currentDomain === "localhost") {
    // Set base URL for local development
    baseUrl = "http://localhost:3000";
  } else if (currentDomain === "zahnarztpraxishassan.web.app") {
    // Set base URL for the production environment
    baseUrl = "https://zahnarztpraxishassan.web.app";
  } else if (currentDomain === "digitalezahnpraxis.at") {
    // Set base URL for another domain
    baseUrl = "https://digitalezahnpraxis.at";
  } else if (currentDomain === "www.digitalezahnpraxis.at") {
    // Set base URL for another domain
    baseUrl = "https://www.digitalezahnpraxis.at";
  } else {
    // Default base URL
    baseUrl = "https://digitalezahnpraxis.at";
  }
  console.log(baseUrl);
  console.log(currentDomain);

  const fetchData = async () => {
    try {
      const response = await fetch(`${baseUrl}/services.json`);
      if (!response.ok) {
        throw new Error('Failed to fetch data from primary URL');
      }
      const data = await response.json();
      setServices(data);
    } catch (fallbackError) {
        console.error('Error fetching data from fallback URL:', fallbackError);
        // Handle ultimate failure (optional):
        // - Display an error message to the user
        // - Set a loading state to indicate data is unavailable
      }
    
  };

  useEffect(() => {
    fetchData();
  }, []);

  return [services];
};

export default useServices;